/** SVG 动态 fill/stroke — 引用 amplifierControl.css 中的 CSS 变量 */

export const AMP_VIS = {
  surface: 'var(--amp-surface-elevated)',
  surfaceInset: 'var(--amp-surface-inset)',
  activeGreenBg: 'var(--amp-active-green-bg)',
  activeGreenBorder: 'var(--amp-active-green-border)',
  powerOrangeBg: 'var(--amp-power-orange-bg)',
  powerOrangeBorder: 'var(--amp-power-orange-border)',
  tuneBlueBg: 'var(--amp-tune-blue-bg)',
  tuneBlueBorder: 'var(--amp-tune-blue-border)',
  border: 'var(--amp-border-strong)',
  fg: 'var(--amp-fg)',
  fgMuted: 'var(--amp-fg-muted)',
  valueAmber: 'var(--amp-value-amber)',
  signal: 'var(--amp-signal)',
  connector: 'var(--amp-connector)',
  rx: 8,
  rxSm: 6,
} as const;

export type AmpNodeSemantic = 'default' | 'power' | 'tune';

export function ampNodeFill(active: boolean, semantic: AmpNodeSemantic = 'default'): string {
  if (!active) return AMP_VIS.surfaceInset;
  switch (semantic) {
    case 'power':
      return AMP_VIS.powerOrangeBg;
    case 'tune':
      return AMP_VIS.tuneBlueBg;
    default:
      return AMP_VIS.activeGreenBg;
  }
}

export function ampNodeStroke(active: boolean, semantic: AmpNodeSemantic = 'default'): string {
  if (!active) return AMP_VIS.border;
  switch (semantic) {
    case 'power':
      return AMP_VIS.powerOrangeBorder;
    case 'tune':
      return AMP_VIS.tuneBlueBorder;
    default:
      return AMP_VIS.activeGreenBorder;
  }
}
